// Generated by CoffeeScript 1.12.7

/*
TODO: should this come bundled with index.coffee?

Allows you to require permissions in order to access a given state. Redirects to
a 403 page if not authorized.

To use:
- add `requirePermission: <actionName>` to the state config
- make sure `$rootScope.googleAuth.employee` will be defined at some point

@example

angular.module __filename, [
  require 'goodeggs-employee-roles/angular/require_permissions'
]

.config ($stateProvider) ->
  $stateProvider.state 'timeclock.reconcile',
    url: ''
    template: require './template'
    requirePermission: 'timeclock.reconcile'
    requirePermissionFrom: 'badge'
 */
angular.module(__filename, ['ui.router', require('../'), require('../access_denied')]).run([
  '$rootScope', 'employeeRoles', '$state', function($rootScope, employeeRoles, $state) {
    return $rootScope.$on('$stateChangeStart', function(e, toState) {
      var ref, ref1, ref2, requirePermissionFrom, roles;
      if (e.pendingLogin) {
        return;
      }
      if (toState.name === 'accessDenied') {
        return;
      }
      if (toState.requirePermission != null) {
        requirePermissionFrom = toState.requirePermissionFrom || 'google';
        roles = (ref = $rootScope.credentials) != null ? (ref1 = ref[requirePermissionFrom]) != null ? (ref2 = ref1.employee) != null ? ref2.roles : void 0 : void 0 : void 0;
        if ((roles == null) || !employeeRoles.can(roles, toState.requirePermission)) {
          e.preventDefault();
          return $state.go('accessDenied', {}, {
            location: false
          });
        }
      }
    });
  }
]);

module.exports = __filename;
